import { WorkerStage } from "@clipboard-health/contract-worker-app-bff";
import { useClipboardScorePolicyLinks } from "@src/appV2/ClipboardScore/hooks/featureFlags";
import { Callout } from "@src/appV2/redesign/system/ui-components";
import { useDefinedWorker } from "@src/appV2/Worker/useDefinedWorker";

export function AccountDeactivatedCallout() {
  const { stage } = useDefinedWorker();

  const { understandingAccountStatus } = useClipboardScorePolicyLinks();

  if (stage !== WorkerStage.DEACTIVATED) {
    return null;
  }

  return (
    <Callout
      title="Your account is deactivated"
      iconType="remove"
      sx={(theme) => ({
        backgroundColor: theme.palette.intent?.error.background,
        color: theme.palette.intent?.error.text,
      })}
      onClick={() => window.open(understandingAccountStatus?.url, "_blank")}
    />
  );
}
